module.exports = __webpack_public_path__ + "media/images/sp/brands/common/brand_menu_campaigns-b7459c111de1b93ff9441681a8b1251b.jpg";